"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithIconWrapper = exports.TitleWithHighlightWrapper = exports.TermsContainer = exports.SignUp = exports.SeeMore = exports.ScrollWayPoint = exports.Ranges = exports.RangeTitle = exports.Range = exports.OfferTitle = exports.OfferDescription = exports.OfferCardWrapper = exports.Logo = exports.Highlight = exports.FirstLook = exports.DetailsWrapper = exports.DetailsLink = exports.DetailsFooter = exports.CtaWrapper = exports.Chevron = exports.CcTermsLink = exports.CcTermsAndText = exports.Card = exports.BottomBorder = exports.AwardIcon = exports.ApplyButton = exports.AdditionalDetails = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ScrollWayPoint = _styledComponents["default"].div.withConfig({
  displayName: "ScrollWayPoint",
  componentId: "sc-1sevkg0-0"
})(["position:absolute;top:-55px;@media (", "){top:-105px;}"], _baseReactComponents.theme.forLargerThanPhone);

exports.ScrollWayPoint = ScrollWayPoint;
var Card = (0, _styledComponents["default"])(_baseReactComponents.StandardCard).withConfig({
  displayName: "Card",
  componentId: "sc-1sevkg0-1"
})(["&&{border:1px solid ", ";padding:24px;margin-bottom:24px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.scuttleGray200;
});
exports.Card = Card;
var OfferCardWrapper = (0, _styledComponents["default"])(_baseReactComponents.StandardCard).withConfig({
  displayName: "OfferCardWrapper",
  componentId: "sc-1sevkg0-2"
})(["&&{padding:16px;margin-bottom:24px;border:1px solid ", ";@media (", "){padding:0 24px 16px;}}"], _baseReactComponents.theme.scuttleGray200, _baseReactComponents.theme.forLargerThanPhone);
exports.OfferCardWrapper = OfferCardWrapper;
var OfferTitle = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "OfferTitle",
  componentId: "sc-1sevkg0-3"
})(["&&{text-align:left;font-size:20px;font-weight:bold;@media (", "){padding:24px 0 0 24px;}}"], _baseReactComponents.theme.forLargerThanPhone);
exports.OfferTitle = OfferTitle;

var Logo = _styledComponents["default"].img.withConfig({
  displayName: "Logo",
  componentId: "sc-1sevkg0-4"
})(["max-width:50%;text-align:center;margin:0 0 24px;@media (", "){height:auto;max-width:100%;}"], _baseReactComponents.theme.forLargerThanPhone);

exports.Logo = Logo;
var ApplyButton = (0, _styledComponents["default"])(_baseReactComponents.Button).withConfig({
  displayName: "ApplyButton",
  componentId: "sc-1sevkg0-5"
})(["margin-bottom:8px;"]);
exports.ApplyButton = ApplyButton;

var FirstLook = _styledComponents["default"].div.withConfig({
  displayName: "FirstLook",
  componentId: "sc-1sevkg0-6"
})(["text-align:center;@media (", "){display:grid;grid-template-columns:25% 75%;grid-template-rows:min-content 1fr;}"], _baseReactComponents.theme.forLargerThanPhone);

exports.FirstLook = FirstLook;
var DetailsLink = (0, _styledComponents["default"])(_baseReactComponents.Link).withConfig({
  displayName: "DetailsLink",
  componentId: "sc-1sevkg0-7"
})([""]);
exports.DetailsLink = DetailsLink;
var OfferDescription = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "OfferDescription",
  componentId: "sc-1sevkg0-8"
})(["&&{display:flex;background-color:", ";padding:16px;border-radius:10px;text-align:left;white-space:pre-line;}"], _baseReactComponents.theme.bubbleBlue100);
exports.OfferDescription = OfferDescription;
var AwardIcon = (0, _styledComponents["default"])(_baseReactComponents.Icon).withConfig({
  displayName: "AwardIcon",
  componentId: "sc-1sevkg0-9"
})(["flex-shrink:0;margin-right:16px;"]);
exports.AwardIcon = AwardIcon;

var CtaWrapper = _styledComponents["default"].div.withConfig({
  displayName: "CtaWrapper",
  componentId: "sc-1sevkg0-10"
})(["display:flex;flex-direction:column;align-items:center;border-bottom:1px solid ", ";padding:24px 0 8px;margin:0 0 16px;@media (", "){padding:24px 24px 24px 0;margin:0;grid-area:1/1/3/2;border-right:1px solid ", ";}"], _baseReactComponents.theme.scuttleGray200, _baseReactComponents.theme.forLargerThanPhone, _baseReactComponents.theme.scuttleGray200);

exports.CtaWrapper = CtaWrapper;

var BottomBorder = _styledComponents["default"].div.withConfig({
  displayName: "BottomBorder",
  componentId: "sc-1sevkg0-11"
})(["@media (", "){border-bottom:1px solid ", ";padding:24px 0 24px 24px;}"], _baseReactComponents.theme.forLargerThanPhone, _baseReactComponents.theme.scuttleGray200);

exports.BottomBorder = BottomBorder;

var Ranges = _styledComponents["default"].div.withConfig({
  displayName: "Ranges",
  componentId: "sc-1sevkg0-12"
})(["display:grid;grid-template-columns:1fr;grid-column-gap:24px;grid-row-gap:16px;padding:16px 0;@media (", "){grid-template-columns:1fr 1fr 1fr 1fr;}"], _baseReactComponents.theme.forLargerThanPhone);

exports.Ranges = Ranges;

var Range = _styledComponents["default"].div.withConfig({
  displayName: "Range",
  componentId: "sc-1sevkg0-13"
})([""]);

exports.Range = Range;
var RangeTitle = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "RangeTitle",
  componentId: "sc-1sevkg0-14"
})(["&&{text-transform:uppercase;margin-bottom:6px;}"]);
exports.RangeTitle = RangeTitle;

var SeeMore = _styledComponents["default"].div.withConfig({
  displayName: "SeeMore",
  componentId: "sc-1sevkg0-15"
})(["&&{text-align:center;border-top:1px solid ", ";padding-top:16px;cursor:pointer;display:flex;justify-content:center;}"], _baseReactComponents.theme.scuttleGray200);

exports.SeeMore = SeeMore;

var Chevron = _styledComponents["default"].div.withConfig({
  displayName: "Chevron",
  componentId: "sc-1sevkg0-16"
})(["width:24px;height:24px;display:flex;margin-left:8px;align-items:center;transform:", ";@media (", "){width:24px;height:24px;}"], function (_ref2) {
  var shouldShowDetails = _ref2.shouldShowDetails;
  return shouldShowDetails && 'rotate(180deg)';
}, _baseReactComponents.theme.forLargerThanPhone);

exports.Chevron = Chevron;

var DetailsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "DetailsWrapper",
  componentId: "sc-1sevkg0-17"
})([""]);

exports.DetailsWrapper = DetailsWrapper;

var AdditionalDetails = _styledComponents["default"].div.withConfig({
  displayName: "AdditionalDetails",
  componentId: "sc-1sevkg0-18"
})([""]);

exports.AdditionalDetails = AdditionalDetails;

var DetailsFooter = _styledComponents["default"].div.withConfig({
  displayName: "DetailsFooter",
  componentId: "sc-1sevkg0-19"
})(["border-top:1px solid ", ";text-align:center;padding:24px 0;"], _baseReactComponents.theme.scuttleGray200);

exports.DetailsFooter = DetailsFooter;

var SignUp = _styledComponents["default"].div.withConfig({
  displayName: "SignUp",
  componentId: "sc-1sevkg0-20"
})(["background-color:", ";border-radius:10px;padding:16px;margin-top:16px;"], _baseReactComponents.theme.mermaidGreen100);

exports.SignUp = SignUp;

var WithIconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "WithIconWrapper",
  componentId: "sc-1sevkg0-21"
})(["display:flex;> svg{margin-right:8px;flex-shrink:0;}"]);

exports.WithIconWrapper = WithIconWrapper;
var Highlight = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "Highlight",
  componentId: "sc-1sevkg0-22"
})(["display:inline-block;padding:0 8px;margin:0 0 8px 0;background-color:", ";text-transform:uppercase;border-radius:4px;letter-spacing:0.5px;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.mermaidGreen300;
});
exports.Highlight = Highlight;

var TitleWithHighlightWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TitleWithHighlightWrapper",
  componentId: "sc-1sevkg0-23"
})(["padding:24px 0 0 24px;text-align:left;> ", "{@media (", "){padding:0;}}"], OfferTitle, _baseReactComponents.theme.forLargerThanPhone);

exports.TitleWithHighlightWrapper = TitleWithHighlightWrapper;
var CcTermsAndText = (0, _styledComponents["default"])(_baseReactComponents.Copy).attrs(function () {
  return {
    size: 'xxs',
    light: true,
    shouldScaleFont: true
  };
}).withConfig({
  displayName: "CcTermsAndText",
  componentId: "sc-1sevkg0-24"
})(["display:inline;"]);
exports.CcTermsAndText = CcTermsAndText;

var TermsContainer = function TermsContainer(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(CcTermsAndText, {
    children: _react["default"].Children.toArray(children).filter(function (child) {
      return !!child;
    }).map(function (child, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [index > 0 && ' | ', child]
      }, index);
    })
  });
};

exports.TermsContainer = TermsContainer;
var CcTermsLink = (0, _styledComponents["default"])(_baseReactComponents.Link).withConfig({
  displayName: "CcTermsLink",
  componentId: "sc-1sevkg0-25"
})(["display:inline;"]);
exports.CcTermsLink = CcTermsLink;
//# sourceMappingURL=offer-styles.js.map